import React from 'react';
import { useStyletron } from 'baseui';
import { LabelMedium, ParagraphSmall } from 'baseui/typography';
import { RelationshipEmptyStateIcon } from '../../icons/relationship-empty-state-icon';
import { CreateRelationshipButton } from './create-relationship-button';
type RelationshipsEmptyStatePropsT = {
  onCreateRelationship?: () => void;
};
export const RelationshipsEmptyState = ({
  onCreateRelationship
}: RelationshipsEmptyStatePropsT) => {
  const [css, theme] = useStyletron();
  return <div className={css({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    padding: `${theme.sizing.scale1000} ${theme.sizing.scale400}`,
    textAlign: 'center'
  })}>
      <RelationshipEmptyStateIcon className={css({
      height: '54px',
      marginBottom: theme.sizing.scale600,
      width: '61px'
    })} />
      <LabelMedium margin={0}>No relationships to show</LabelMedium>
      <ParagraphSmall color={theme.colors.contentSecondary} marginTop={theme.sizing.scale200}>
        Create a relationship for this object to manage here
      </ParagraphSmall>
      <CreateRelationshipButton label="Create relationship" onClick={onCreateRelationship} variant="button" />
    </div>;
};